import React from 'react';
import Checkbox from './FilterInputs/Checkbox';
import Select from './FilterInputs/Select';
import SimpleSelect from './FilterInputs/SimpleSelect';
import Slider from './FilterInputs/Slider';
import Input from './FilterInputs/Input';

const filterMap = {
    checkbox: Checkbox,
    select: Select,
    slider: Slider,
    text: Input,
    simpleSelect: SimpleSelect
};

export default function (item = null, handleChange = () => {}, value = null) {
    if (item && Object.keys(filterMap).indexOf(item.type) > -1) {
        let props = {
            item,
            handleChange,
            value
        };
        return React.createElement(filterMap[item.type], props);
    }
    return null;
}